import React from 'react';
import { Link } from '../router/Link';

const INFO_ROWS = [
  { label: '상호', value: '노라네코 (Noraneko)' },
  { label: '대표자', value: '손호영' },
  { label: '사업자등록번호', value: '842-24-02387' },
  { label: '이메일', value: 'me@pyrimidines.org' },
  { label: '고객 문의', value: 'support@noraneko.cc' },
  { label: '서비스명', value: 'GirlsBandTabi' },
];

const LEGAL_LINKS = [
  { id: 'terms', label: '이용약관' },
  { id: 'privacy', label: '개인정보처리방침' },
  { id: 'community', label: '커뮤니티 이용규칙' },
  { id: 'location', label: '위치정보 이용약관' },
];

const BusinessPage: React.FC = () => {
  return (
    <main
      style={{
        maxWidth: '52rem',
        margin: '0 auto',
        padding: '3rem 1.5rem 6rem',
        position: 'relative',
        zIndex: 1,
      }}
    >
      <header style={{ marginBottom: '2.5rem' }}>
        <p
          style={{
            fontSize: '0.65rem',
            letterSpacing: '0.3em',
            textTransform: 'uppercase',
            color: 'var(--muted)',
            margin: '0 0 0.5rem',
          }}
        >
          Noraneko · Business
        </p>
        <h1
          style={{
            fontFamily: 'var(--font-display)',
            fontSize: 'clamp(2rem, 6vw, 3.5rem)',
            letterSpacing: '0.04em',
            margin: 0,
            color: 'var(--text)',
          }}
        >
          사업자 정보
        </h1>
      </header>

      {/* Business info table */}
      <section
        aria-label="사업자 정보"
        style={{
          background: 'var(--card)',
          border: '1px solid var(--stroke)',
          borderRadius: 'var(--radius)',
          overflow: 'hidden',
          marginBottom: '2rem',
        }}
      >
        {INFO_ROWS.map((row, i) => (
          <div
            key={row.label}
            style={{
              display: 'grid',
              gridTemplateColumns: '9rem 1fr',
              borderBottom: i < INFO_ROWS.length - 1 ? '1px solid var(--stroke-subtle)' : 'none',
              padding: '0.875rem 1.5rem',
            }}
          >
            <dt
              style={{
                fontSize: '0.75rem',
                fontWeight: 600,
                letterSpacing: '0.03em',
                color: 'var(--muted)',
              }}
            >
              {row.label}
            </dt>
            <dd
              style={{
                margin: 0,
                fontSize: '0.875rem',
                color: 'var(--text)',
                fontWeight: 500,
              }}
            >
              {row.value}
            </dd>
          </div>
        ))}
      </section>

      {/* Legal links */}
      <section aria-label="법무 문서">
        <h2
          style={{
            fontSize: '0.75rem',
            fontWeight: 700,
            letterSpacing: '0.1em',
            textTransform: 'uppercase',
            color: 'var(--muted)',
            margin: '0 0 1rem',
          }}
        >
          법무 문서
        </h2>
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(12rem, 1fr))',
            gap: '0.75rem',
          }}
        >
          {LEGAL_LINKS.map((doc) => (
            <Link
              key={doc.id}
              to={`/legal?doc=${doc.id}`}
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                background: 'var(--card)',
                border: '1px solid var(--stroke)',
                borderRadius: 'var(--radius)',
                padding: '0.875rem 1rem',
                fontSize: '0.8rem',
                fontWeight: 600,
                color: 'var(--text)',
                textDecoration: 'none',
                transition: 'border-color 0.15s',
              }}
            >
              {doc.label}
              <span style={{ color: 'var(--muted)', fontSize: '0.7rem' }}>→</span>
            </Link>
          ))}
        </div>
      </section>
    </main>
  );
};

export default BusinessPage;
